export default "__VITE_ASSET__4cb5d272__"